(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["si-article-ausom"]) return;
  try {
    
function initAusomArticle(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const content = root.querySelector('.sia-content');
  const nav = root.querySelector('.sia-toc');
  const list = nav.querySelector('ol');
  content.querySelectorAll('h2').forEach((heading, index) => {
    if (!heading.id) heading.id = content.id + '-part-' + index;
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = '#' + heading.id;
    a.textContent = heading.textContent;
    li.append(a);
    list.append(li);
  });
  nav.hidden = !list.children.length;
}
document.querySelectorAll('[data-si-article]').forEach(initAusomArticle);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-si-article]').forEach(initAusomArticle));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["si-article-pall"]) return;
  try {
    
function initPallArticle(root){if(root.dataset.ready)return;root.dataset.ready='true';const content=root.querySelector('.sia-content'),nav=root.querySelector('.sia-toc'),list=nav.querySelector('ol');content.querySelectorAll('h2').forEach((h,i)=>{h.id=h.id||content.id+'-'+i;const li=document.createElement('li'),a=document.createElement('a');a.href='#'+h.id;a.textContent=h.textContent;li.append(a);list.append(li)});nav.hidden=!list.children.length;const success=root.querySelector('.sp-success');if(success)success.focus()}
document.querySelectorAll('[data-pall-article]').forEach(initPallArticle);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-pall-article]').forEach(initPallArticle));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["si-charger-finder"] && !Shopify.designMode) return;
  try {
    
function initSourceitFinder(root){if(root.dataset.ready)return;root.dataset.ready='true';const form=root.querySelector('form');const steps=[...root.querySelectorAll('[data-step]')];if(!steps.length)return;const next=root.querySelector('[data-next]'),back=root.querySelector('[data-back]'),send=root.querySelector('[data-send]'),progress=root.querySelector('.sif-progress');let index=0;root.classList.add('js-ready');progress.hidden=false;root.querySelector('progress').max=steps.length;form.noValidate=true;
function summary(){const box=root.querySelector('[data-summary]');box.replaceChildren();for(const [name,value]of new FormData(form)){if(!name.startsWith('contact[')||!value)continue;const p=document.createElement('p'),b=document.createElement('strong');b.textContent=name.slice(8,-1)+' : ';p.append(b,document.createTextNode(value));box.append(p)}}
function show(focus){steps.forEach((s,i)=>s.hidden=i!==index);back.hidden=index===0;next.hidden=index===steps.length-1;send.hidden=index!==steps.length-1;root.querySelector('progress').value=index+1;root.querySelector('[data-step-text]').textContent='Étape '+(index+1)+' sur '+steps.length;if(index===steps.length-1)summary();if(focus){const target=steps[index].querySelector('legend');target.tabIndex=-1;target.focus({preventScroll:true})}}
function validStep(step){const invalid=[...step.querySelectorAll('input,textarea,select')].find(x=>!x.checkValidity());if(invalid){invalid.reportValidity();return false}return true}
next.addEventListener('click',()=>{if(validStep(steps[index])){index++;show(true)}});back.addEventListener('click',()=>{index--;show(true)});form.addEventListener('submit',e=>{if(index<steps.length-1){e.preventDefault();next.click();return}const bad=steps.findIndex(s=>!validStepNoReport(s));if(bad>=0){e.preventDefault();index=bad;show(true);validStep(steps[index])}});function validStepNoReport(s){return [...s.querySelectorAll('input,textarea,select')].every(x=>x.checkValidity())}show(false)}
document.querySelectorAll('.sif').forEach(initSourceitFinder);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.sif').forEach(initSourceitFinder));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["si-home-draft"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
 const button=event.target.closest('[data-brand-direction]');
 if(!button)return;
 const rail=button.closest('.sih-universe-row').querySelector('.sih-brand-rail');
 if(rail)rail.scrollBy({left:Number(button.dataset.brandDirection)*rail.clientWidth*.8,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
});


  } catch(e) { console.error(e); }
})();
})();
